import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import CspResourceForm from "@/components/csp-resources/CspResourceForm";
import CspResourceTable from "@/components/csp-resources/CspResourceTable";

export const Route = createFileRoute("/dashboard/resources/upload")({
    component: RouteComponent,
});

function RouteComponent() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden bg-white">
            <CspResourceTable
                scope="all"
                onSendResource={() => setIsModalOpen(true)}
            />
            {isModalOpen && (
                <CspResourceForm onClose={() => setIsModalOpen(false)} />
            )}
        </div>
    );
}
